'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import QuickShipBanner from './QuickShipBanner';
import StatisticsBar from './StatisticsBar';
import PartnerShowcase from './PartnerShowcase';
import ToolsSection from './ToolsSection';
import LeadCaptureSection from './LeadCaptureSection';
import StickyMobileQuote from './StickyMobileQuote';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <>
      <HeroSection isHydrated={isHydrated} />
      <QuickShipBanner />
      <StatisticsBar />
      <PartnerShowcase isHydrated={isHydrated} />
      <ToolsSection />
      <LeadCaptureSection />
      <StickyMobileQuote />
    </>
  );
};

export default HomepageInteractive;